import { api } from './api';

export interface ReglaPropina {
  id: number;
  tenantId: number;
  sucursalId?: number;
  name: string;
  tipo: 'porcentaje' | 'fijo';
  valor: number;
  minimoOrden?: number;
  maximoOrden?: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface ReglaPropinaCreate {
  name: string;
  tipo: 'porcentaje' | 'fijo';
  valor: number;
  sucursalId?: number;
  minimoOrden?: number;
  maximoOrden?: number;
}

export interface ReglaPropinaUpdate {
  name?: string;
  tipo?: 'porcentaje' | 'fijo';
  valor?: number;
  minimoOrden?: number;
  maximoOrden?: number;
  isActive?: boolean;
}

export interface CalculoPropina {
  subtotal: number;
  propina: number;
  regla: ReglaPropina | null;
  total: number;
}

export const reglaPropinaService = {
  getAll: async (sucursalId?: number): Promise<{ data: { reglas: ReglaPropina[] } }> => {
    const params = sucursalId ? `?sucursalId=${sucursalId}` : '';
    const response = await api.get<{ data: { reglas: ReglaPropina[] } }>(`/reglas-propinas${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { regla: ReglaPropina } }> => {
    const response = await api.get<{ data: { regla: ReglaPropina } }>(`/reglas-propinas/${id}`);
    return response.data;
  },

  calcular: async (subtotal: number, sucursalId?: number): Promise<{ data: CalculoPropina }> => {
    const response = await api.post<{ data: CalculoPropina }>('/reglas-propinas/calcular', {
      subtotal,
      sucursalId
    });
    return response.data;
  },

  create: async (data: ReglaPropinaCreate): Promise<{ data: { regla: ReglaPropina } }> => {
    const response = await api.post<{ data: { regla: ReglaPropina } }>('/reglas-propinas', data);
    return response.data;
  },

  update: async (id: number, data: ReglaPropinaUpdate): Promise<{ data: { regla: ReglaPropina } }> => {
    const response = await api.put<{ data: { regla: ReglaPropina } }>(`/reglas-propinas/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/reglas-propinas/${id}`);
    return response.data;
  }
};

